import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentInstanceService {
  private usersList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private usersList;

  private groupsList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private groupsList;

  constructor(
    private userService: UserService
  ) { }

  public get roles() {
    return this.usersList$.value
  }

  public get groups() {
    return this.groupsList$.value
  }

  public setInstance(instance) {
    this.userService.getUserGroups().subscribe( res => {
      let newGroupsArray = res['data']
      let transformedGroups = newGroupsArray.map( (item)=> ({
        value: item.attributes.name,
        viewValue: item.attributes.name.charAt(0).toUpperCase() + item.attributes.name.slice(1).replace('_', ' ')
      })
      )
      this.groupsList$.next(transformedGroups)
    })

    this.userService.getUserRoles().subscribe( res => {
      let newRolesArray = res['data']['roles']
      let transformedRoles = newRolesArray.map( (item)=> ({
        value: item,
        viewValue: item.charAt(0).toUpperCase() + item.slice(1).replace('_', ' ')
      })
      )
      this.usersList$.next(transformedRoles)
    })
  }
}
